<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click.stop="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('components.ModelAccessManager.userAccessFor') }} {{ clientName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.stop="save">{{ $t('components.ModelAccessManager.save') }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-row>
      <v-col cols="12">
        <v-data-table v-model="selectedUsers" :headers="headers" :items="userList.filter(user => user.id !== userId)" class="elevation-1" style="width: 95%;" show-select item-key="id" disable-pagination hide-default-footer :search="searchUsers" :loading="loading">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchUsers"
                append-icon="mdi-magnify"
                :label="$t('components.ModelAccessManager.search')"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      searchUsers: '',
      originalSelectedUsers: [],
      selectedUsers: [],
      loading: true
    }
  },
  methods: {
    ...mapActions('manager', [
      'loadUserList',
      'batchSaveModelUserAccess',
      'loadModelUserAccess'
    ]),
    close: function () {
      this.$emit('close')
    },
    save: function () {
      // Fix: filter out users without IDs and map correctly
      const selectedUsersArray = this.selectedUsers
        .filter(user => user && (user.id || user.uid || user.email))
        .map(user => user.id || user.uid || user.email)
      const enabledUsers = selectedUsersArray.filter(x => !this.originalSelectedUsers.includes(x))
      const disabledUsers = this.originalSelectedUsers.filter(x => !selectedUsersArray.includes(x) && x !== this.userId)

      // Convert to the format expected by batchSaveModelUserAccess
      // Combine all user changes into a single array, ensuring each user only appears once
      const userChangesMap = {}

      // Process enabled users
      enabledUsers.forEach(userId => {
        if (userId) { // Validate userId is not empty
          if (!userChangesMap[userId]) {
            userChangesMap[userId] = {
              userId: userId,
              enabledClients: [],
              disabledClients: []
            }
          }
          userChangesMap[userId].enabledClients.push(this.clientId)
        }
      })

      // Process disabled users
      disabledUsers.forEach(userId => {
        if (userId) { // Validate userId is not empty
          if (!userChangesMap[userId]) {
            userChangesMap[userId] = {
              userId: userId,
              enabledClients: [],
              disabledClients: []
            }
          }
          userChangesMap[userId].disabledClients.push(this.clientId)
        }
      })

      // Convert map to array
      const userChanges = Object.values(userChangesMap)

      // Only make the call if there are changes to save
      if (userChanges.length > 0) {
        this.batchSaveModelUserAccess({
          userChanges: userChanges
        }).then(() => {
          this.close()
        }).catch(error => {
          console.error('Error saving model user access:', error)
        })
      } else {
        this.close()
      }
    }
  },
  computed: {
    ...mapGetters('manager', [
      'userList'
    ]),
    headers () {
      return [
        { text: this.$t('components.ModelAccessManager.name'), value: 'firstName' },
        { text: this.$t('components.ModelAccessManager.lastname'), value: 'lastName' },
        { text: this.$t('components.ModelAccessManager.email'), value: 'email' }
      ]
    }
  },
  created: async function () {
    await Promise.all([this.loadUserList(), this.loadModelUserAccess({ clientId: this.clientId }).then(users => {
      this.selectedUsers = this.userList.filter(user => users.includes(user.id))
      // Fix: use the same mapping logic as in save function
      this.originalSelectedUsers = this.selectedUsers
        .filter(user => user && (user.id || user.uid || user.email))
        .map(user => user.id || user.uid || user.email)
    }
    )])
    this.loading = false
  },
  props: {
    clientName: {
      type: String,
      required: true
    },
    clientId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  }
}
</script>
